import { render, staticRenderFns } from "./UserMissing.vue?vue&type=template&id=060f1d2a&scoped=true&"
import script from "./UserMissing.vue?vue&type=script&lang=js&"
export * from "./UserMissing.vue?vue&type=script&lang=js&"
import style0 from "./UserMissing.vue?vue&type=style&index=0&id=060f1d2a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060f1d2a",
  null
  
)

export default component.exports